import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon
} from 'react-share';
import { store } from '../../configureStore';
import orm from '../../orm';
import { appGetNNHashSelector, appGetTitleSelector } from '../app/selectors';


const DEBUG = true;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

function SharingProviders() {

  let nnHash = appGetNNHashSelector(store.getState());
  const title = appGetTitleSelector(store.getState());

  const session = orm.session(store.getState().orm);
  const { Experience, Map, NavNode } = session;
  
  // @ts-ignore
  const currentNavNode = NavNode.withId(nnHash);
  debugLog('SharingProviders - currentNavNode : ' + JSON.stringify(currentNavNode, null, 2));
  const experienceId = currentNavNode?.experienceId;
  // @ts-ignore
  const currentExperience = Experience.withId(experienceId);
  debugLog('SharingProviders - currentExperience - ' + JSON.stringify(currentExperience, null, 2));
  
  const webReleaseUrl = currentExperience?.webReleaseUrl;
  debugLog('SharingProviders - webReleaseUrl : ' + webReleaseUrl);

  // const shareUrl = `${webReleaseUrl}${process.env.REACT_APP_BASENAME}/#nn=${nnHash}`;
  const shareUrl = `${webReleaseUrl}/#nn=${nnHash}`;
  debugLog('SharingProviders - shareUrl : ' + shareUrl);


  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch Content Sharing Modal
      </Button> */}

      <div className="Demo__container" style={{
        display: 'flex',
        justifySelf: 'center',
        alignSelf: 'center',
        flexWrap: 'wrap',
        // width: width * 0.3,
        justifyContent: 'space-evenly',
      }}>

        <div className="Demo__some-network" style={{ margin: '20px' }}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>

        <div className="Demo__some-network" style={{ margin: '20px' }}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>

        <div className="Demo__some-network" style={{ margin: '20px' }}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>

        <div className="Demo__some-network" style={{ margin: '20px' }}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>

        <div className="Demo__some-network" style={{ margin: '20px' }}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>

      </div>
    </>
  );
}

export default SharingProviders;

